class MenuItem {
  constructor ({label, href, icon = undefined, subMenus = [], badge = 0, key = ''}) {
    this.key = key
    this.label = label
    this.href = href
    this.active = false
    this.icon = icon
    this.badge = badge

    subMenus.forEach(item => {
      if (!(item instanceof MenuItem)) {
        throw new Error('Invalid submenu item given, must be an instance of MenuItem.')
      }
    })

    this.subMenu = subMenus
  }

  isActive () {
    return this.active === true
  }

  hasSubMenu () {
    return this.subMenu.length > 0
  }
}

export default MenuItem



// WEBPACK FOOTER //
// ./src/lib/transfer-objects/MenuItem.js